package com.iregained.site.components.widgets

import androidx.compose.runtime.*
import com.iregained.site.theme.HeadlineTextStyle
import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.Div

@Composable
fun SectionHeader(
    text: String,
    textColor: Color = ColorMode.current.toSitePalette().custom.darkText,
    lineColor: Color = ColorMode.current.toSitePalette().brand.primary,
    fontSize: CSSSizeValue<CSSUnit.px> = 36.px,
    modifier: Modifier = Modifier,
    lineWidthPercent: CSSSizeValue<CSSUnit.percent> = 25.percent,
    alignment: Alignment.Horizontal = Alignment.CenterHorizontally
) {
    var isVisible by remember { mutableStateOf(false) }

    if (text.isNotBlank()) {
        val mappedTextAlign = when (alignment) {
            Alignment.Start -> TextAlign.Start
            Alignment.End -> TextAlign.End
            else -> TextAlign.Center
        }

        val mappedJustifyContent = when (alignment) {
            Alignment.Start -> JustifyContent.FlexStart
            Alignment.End -> JustifyContent.FlexEnd
            else -> JustifyContent.Center
        }

        Div(attrs = modifier.fillMaxWidth().display(DisplayStyle.Flex).justifyContent(mappedJustifyContent).toAttrs {
            ref { element ->
                val observer = IntersectionObserver { entries, obs ->
                    entries.forEach {
                        if (it.isIntersecting) {
                            isVisible = true; obs.unobserve(element)
                        }
                    }
                }
                observer.observe(element); onDispose { observer.disconnect() }
            }
        }) {
            Column(horizontalAlignment = alignment) {
                // Fade in text
                Div(
                    attrs = HeadlineTextStyle.toModifier().color(textColor).opacity(0.75f).fontSize(fontSize)
                        .fontWeight(FontWeight.Bold).textAlign(mappedTextAlign).letterSpacing(2.px)
                        .margin(bottom = 16.px).textTransform(TextTransform.Uppercase).opacity(if (isVisible) 1 else 0)
                        .translateY(if (isVisible) 0.px else 10.px).transition(
                            Transition.of("opacity", 0.6.s, TransitionTimingFunction.EaseOut),
                            Transition.of("transform", 0.6.s, TransitionTimingFunction.EaseOut)
                        ).toAttrs {
                            ref { htmlElement ->
                                htmlElement.innerHTML = text
                                onDispose {}
                            }
                        }
                )

                // UNIQUE ANIMATION: Line Draw Reveal
                Box(
                    modifier = Modifier.width(if (isVisible) lineWidthPercent else 0.percent) // Animates from 0% to the target %
                        .height(4.px).borderRadius(2.px).backgroundColor(lineColor)
                        .transition(Transition.of("width", 0.8.s, TransitionTimingFunction.EaseOut, delay = 200.ms))
                )
            }
        }
    }
}